export default __webpack_public_path__ + "static/090-e2f5c8302d36b16a71f507af3e70eda1.jpg";